(() => {
  const toBoolean = (value) => value === 'true';

  const mountSlider = (container) => {
    if (!window.Splide || container.splide) return;

    const splideElement = container.querySelector('.splide');
    if (!splideElement) return;

    const slideCount = splideElement.querySelectorAll('.splide__slide').length;
    const fullscreen = container.classList.contains('slideshow-custom--fullscreen');

    const splide = new Splide(splideElement, {
      type: slideCount > 1 ? 'fade' : 'slide',
      rewind: true,
      autoplay: slideCount > 1 && toBoolean(container.dataset.autoplay),
      interval: Number(container.dataset.interval) || 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows: slideCount > 1 && toBoolean(container.dataset.arrows),
      pagination: slideCount > 1,
      speed: 800,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: slideCount > 1,
      keyboard: 'focused',
      autoHeight: !fullscreen,
    });

    splide.mount();
    container.splide = splide;
  };

  const destroySlider = (container) => {
    const splide = container.splide;
    if (!splide) return;

    splide.destroy(true);
    delete container.splide;
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-slideshow-custom]').forEach(mountSlider);
  };

  document.addEventListener('DOMContentLoaded', () => mountAll());

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-slideshow-custom]').forEach(destroySlider);
  });
})();
